import { SelectInput } from "components/FormControls/Select/Select";
import { maxVisibleConditionDataCount } from "components/Layout/Segment/SegmentForm/SegmentForm";
import { MoreElements } from "components/MoreElements/MoreElements";
import { genderList } from "constants/general";
import { useMessage } from "hooks/intl";
import { get } from "lodash";
import { Gender as GenderType } from "types/segments";
import { alphabetizeByProperty } from "utilities/arrays";
import { useStyles } from "./SegmentConditions.styles";

export const initialValuesGender: GenderType = {
  options: [],
  type: "gender",
};

export function Gender({
  formField,
  values,
  readOnly,
}: {
  formField: string;
  values: any;
  readOnly?: boolean;
}) {
  const { message } = useMessage();
  const classes = useStyles();
  const fieldName = `${formField}.options`;
  const value = get(values, formField);

  return (
    <>
      {value.isConditionSaved || readOnly ? (
        <>
          {message({ id: "is_one_of" }).toLocaleLowerCase()}{" "}
          {value?.options
            ?.slice(0, maxVisibleConditionDataCount)
            ?.map((gender: string, index: number) => (
              <div className={classes.box} key={index}>
                {gender}
              </div>
            ))}
          <MoreElements totalItemsNumber={value?.options?.length} />
        </>
      ) : (
        <SelectInput
          className={classes.input}
          multiple
          data-test-id="segment-conditions-gender-select"
          width="100%"
          items={alphabetizeByProperty(
            genderList.map((gender: string) => ({
              label: message({ id: gender }),
              id: gender,
            })),
            "label",
          )}
          label={message({ id: "gender" })}
          name={fieldName}
          placeholder={message({ id: "addGender" })}
        />
      )}
    </>
  );
}
